import { createSlice } from '@reduxjs/toolkit'

export const OfferEngineSlice = createSlice({
  name: 'offerEngine',
  initialState: {
    cardOfferDetails: null,
    upiOfferDetails: null,
    showOfferEngine: false,
    selectedOffer: {},
  },
  reducers: {
    setCardOfferDetails: (state, action) => {
      state.cardOfferDetails = action.payload
    },
    setUpiOfferDetails: (state, action) => {
      state.upiOfferDetails = action.payload
    },
    setShowOfferEngine: (state, action) => {
      state.showOfferEngine = action.payload
    },
    setSelectedOffer: (state, action) => {
      state.selectedOffer = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setSelectedOffer, setShowOfferEngine, setCardOfferDetails, setUpiOfferDetails } = OfferEngineSlice.actions

export default OfferEngineSlice.reducer